import { trimmValue } from '../helpers';

export const required = (message: string) => (value: any) => {
  return !trimmValue(value) ? message : undefined;
};
